module.exports = __webpack_public_path__ + "static/media/en.710ecc0f.svg";